import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackViewFilter = ({ element, context, filterLvl, filtersValue, length, campaignId, }) => {
    const viewFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl === 0 ? 0 : filterLvl || null,
        filters_value: filtersValue,
        length: length || null,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-view_filter', {
        event_name: 'view_filter',
        view_filter: viewFilter,
    });
};
